<template>
  <div class="col-md-3 auctions__sidenav">
    <ul>
      <li :class="{ active: isActive(`/employees/${auctionType}/auctions_catalogs`) }">
        <span class="icon icon-auction"></span>
        <router-link :to="{ name: 'employeesAuctionsCatalogs', params: { auctionType: $route.params.auctionType } }">
          {{I18n.t('employees.auctions_catalogs.sidenav.auctions')}}
        </router-link>
      </li>
      <li :class="{ active: isActive(`/employees/${auctionType}/finished/auctions_catalogs`) }">
        <span class="icon icon-stats-bars"></span>
        <router-link :to="{ name: 'employeesFinishedAuctionsCatalogs', params: { auctionType: auctionType } }">
          {{I18n.t('employees.auctions_catalogs.sidenav.results')}}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  /* global Routes */
  export default {
    name: 'AuctionsCatalogsSidebar',
    created() {
      this.Routes = Routes;
    },
    computed: {
      auctionType() {
        return this.$route.params.auctionType;
      },
    },
    methods: {
      isActive(tabPath) {
        return this.$route.path === tabPath;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/auctions_catalogs_sidebar.vue?64062190